<script>
export default {
  data() {
    return {
      contacts: [
        {
          label: 'callUs',
          url: 'tel:33257666',
          text: '+387 33 257 666; +387 51 981 330',
          icon: 'phone-call-outline'
        },
        {
          label: 'email',
          url: 'mailto:info@iutecredit.ba',
          text: 'info@iutecredit.ba',
          icon: 'email-outline'
        },
        {
          label: 'viber',
          url: 'viber://pa/?chatURI=iutecreditbosnia',
          text: 'iutecreditbosnia',
          icon: 'social-viber'
        }
      ],
      socials: [
        {
          label: 'facebook',
          url: 'https://www.facebook.com/iutecreditbih',
          text: 'iutecreditbih',
          icon: 'social-facebook'
        },
        {
          label: 'instagram',
          url: 'https://www.instagram.com/iutecreditbih/?hl=en',
          text: 'iutecreditbih',
          icon: 'social-instagram'
        },
        {
          label: 'youtube',
          url: 'https://www.youtube.com/channel/UC6MeLm0IaQuosdVlG2z0eGA',
          text: 'IuteCredit Bosna i Hercegovina',
          icon: 'social-youtube'
        },
        {
          label: 'linkedin',
          url: 'https://ba.linkedin.com/company/iutecredit-bosnia',
          text: 'iutecredit-bosnia',
          icon: 'social-linkedin'
        },
        {
          label: 'internet',
          url: 'http://www.iutecredit.ba',
          text: 'www.iutecredit.ba',
          icon: 'globe-2-outline'
        }
      ]
    }
  }
}
</script>
